enum PlanDetectionStatus {
    Pending = 'Pending', 
    Running = 'Running', 
    Completed = 'Completed', 
    Failed = 'Failed'
}

export default PlanDetectionStatus;